import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThermostat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconThermostat"><Path d="M11.5 2H6.5V12.6689C5.0055 13.5334 4 15.1493 4 17C4 19.7614 6.23858 22 9 22C11.7614 22 14 19.7614 14 17C14 15.1493 12.9945 13.5334 11.5 12.6689V2Z" fill="currentColor"/><Path d="M15 3.5V5H20V3.5H15Z" fill="currentColor"/><Path d="M15 7.5V9H20V7.5H15Z" fill="currentColor"/><Path d="M15 13V11.5H20V13H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThermostat;
